export default {
	DUPLICATED_LESSON_NAME: 1,
	UNTITLED_LESSON: 2,
	NOT_ENOUGH_SPACE_IN_MY_LIBRARY: 2,
	LESSON_LAUNCH_NOT_READY: 3,
	EXCEED_MAX_PRESENTATION_SIZE: 20,
	EXCEED_MAX_USER_STORAGE: 21,
	EXCEED_MAX_FILE_SIZE: 23,
	EXCEED_MAX_CHARS: 24,
	STATUS_INVALID_DEVICE_UID: 61,
	STATUS_DUPLICATED_PARTICIPANT: 63,
	STATUS_EXISTENT_PARTICIPANT: 64,
	OPERATION_NOT_PERMITED: 83,
	STATUS_JOIN_LIMIT_ERROR: 100,
	NOT_FOUND: 404,
	LESSON_WITH_COLLABORATE_SLIDES: 101,
	ICON_INVALID_CONTENT_INTEGRITY: 1004,
	PRIVATE_LIBRARY_CP_ACCESS_DENIED: 1100,
	PAYWALLS_ALREADY_ON_FREE_TRIAL: 1200,
	GOOGLE_SLIDES_EDIT_NON_NEARPOD_SLIDE: 1400,
	GOOGLE_SLIDES_POP_UP_BLOCKED: 1401,
	GOOGLE_SLIDES_EDIT_AUDIO_SLIDE: 1402,
	GOOGLE_SLIDES_SAVE_MEDIA_FAILED: 1403,
	GOOGLE_SLIDES_INVALID_PERMISSIONS_ERROR: 1404,
	LESSON_ALREADY_PUBLISHED: 1700,
	COOKIES_FAILED: 1,
	SIGNUP_EXISTING_EMAIL: 1800,
	GOOGLE_SLIDES_SAVE_ALREADY_PUBLISHED: 1405,
	LESSON_DUPLICATED_NAME: 1701,
	LESSON_UNTITLED: 1702,
	ADD_TO_PL_CHOOSE_FOLDER: 36,
	RESET_PASSWORD_INVALID: 1900,
	ADDON_NOT_SUPPORTED: 1406,
}
